import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import RegisterService from "../../services/register.service";



// export const getRegister = createAsyncThunk(
//   "register/getRegister",
//   async (params, thunkAPI) => {
//     try {
//       const response = await RegisterService.getPlan(params);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message
//       );
//     }
//   }
// );

export const userRegister = createAsyncThunk(
  "register/userRegister",
  async (data, thunkAPI) => {
    try {
      const response = await RegisterService.userRegister(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const userUploadAadhaar = createAsyncThunk(
  "uploadaadhar/userUploadAadhar",
  async (data, thunkAPI) => {
    try {
      const response = await RegisterService.uploadAadhaar(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// export const updatePlan = createAsyncThunk(
//   "plan/updatePlan",
//   async (payload, thunkAPI) => {
//     try {
//       const response = await PlanService.editPlan(payload);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message
//       );
//     }
//   }
// );

// export const deletePlan = createAsyncThunk(
//   "plan/deletePlan",
//   async (id, thunkAPI) => {
//     try {
//       await PlanService.deletePlan(id);
//       return id;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message
//       );
//     }
//   }
// );



const initialState = {
  loading: false,
  error: null,
  registerlist: [],
  useruploadaadhar:[],
  updateSuccess: false,
};



const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      // .addCase(getPlan.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(getPlan.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.planlist = action.payload?.data || [];
      // })
      // .addCase(getPlan.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      /* ---------- Add ---------- */
      .addCase(userRegister.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        state.loading = false;

        const newRegister =
          action.payload?.data ||
          action.payload?.registerData ||
          action.payload;

        if (newRegister) {
          state.registerlist.unshift(newRegister);
        }
      })
      .addCase(userRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(userUploadAadhaar.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userUploadAadhaar.fulfilled, (state, action) => {
        state.loading = false;

        const uploadAadhaar =
          action.payload?.data ||
          action.payload?.registerData ||
          action.payload;

        if (uploadAadhaar) {
          state.useruploadaadhar.unshift(uploadAadhaar);
        }
      })
      .addCase(userUploadAadhaar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      // .addCase(updatePlan.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      //   state.updateSuccess = false;
      // })
      // .addCase(updatePlan.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.updateSuccess = true;

      //   const updated =
      //     action.payload?.data || action.payload?.planData;

      //   if (updated?._id && Array.isArray(state.planlist)) {
      //     const index = state.planlist.findIndex(
      //       (item) => item._id === updated._id
      //     );

      //     if (index !== -1) {
      //       state.planlist[index] = updated;
      //     }
      //   }
      // })
      // .addCase(updatePlan.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      /* ---------- Delete ---------- */
      // .addCase(deletePlan.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(deletePlan.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.planlist = state.planlist.filter(
      //     (item) => item._id !== action.payload
      //   );
      // })
      // .addCase(deletePlan.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // });
  },
});

export const { resetUpdateStatus } = registerSlice.actions;
export default registerSlice.reducer;
